// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import NavLink from 'src/components/NavLink/NavLink';
import SignInRegisterLink, {
  LOGIN_MODES
} from 'src/components/SignInRegisterLink/SignInRegisterLink';

import { campaignLinkClicked } from 'src/store/location/location';
import SkewBannerTemplate from '../SkewBannerTemplate/SkewBannerTemplate';

type Props = {
  authenticated: boolean,
  bannerClickLoggedIn: Function,
  bannerClickLoggedOut: Function
};

const mapStateToProps = ({ user }) => ({
  authenticated: user.authenticated
});

const mapDispatchToProps = dispatch => ({
  bannerClickLoggedIn: () => {
    dispatch(
      campaignLinkClicked({
        linkName: 'houston:logged+in+banner',
        trackingCode:
          'sk:main:au:home:loggedinbanner:profile:update+your+profile+v2'
      })
    );
  },
  bannerClickLoggedOut: () => {
    dispatch(
      campaignLinkClicked({
        linkName: 'houston:logged+out+banner',
        trackingCode:
          'sk:main:au:home:loggedoutbanner:profile:update+your+profile+v2'
      })
    );
  }
});

class ProfileBanner extends PureComponent<Props> {
  props: Props;

  render() {
    const {
      bannerClickLoggedIn,
      bannerClickLoggedOut,
      authenticated
    } = this.props;
    const WrapperComponent = authenticated ? NavLink : SignInRegisterLink;
    const buttonCopy = authenticated ? 'Update now' : 'Create now';

    const profilePagePathname = '/profile/me';

    const linkProps = authenticated
      ? {
          location: profilePagePathname,
          analytics: 'profile-banner-clicked',
          preNavigationHooks: [bannerClickLoggedIn]
        }
      : {
          mode: LOGIN_MODES.REGISTER,
          preNavigationHooks: [bannerClickLoggedOut],
          analytics: 'profile-banner-clicked',
          returnLocation: { pathname: profilePagePathname }
        };

    const headlineCopy = authenticated
      ? 'Your SEEK Profile never stops searching for your next job'
      : 'A SEEK Profile lets opportunity come to you';

    const SkewBannerTemplateProps = {
      linkProps,
      WrapperComponent,
      headlineCopy,
      buttonCopy,
      imageVariant: 'profileBanner'
    };

    return <SkewBannerTemplate {...SkewBannerTemplateProps} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileBanner);
